/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import { useState, useEffect } from 'react';

export const useDarkMode = (def:string) => {
    // const [color, set]
    const [theme, setTheme] = useState(def);

    const setMode = (mode: string) => {
        setTheme(mode);
        window.localStorage.setItem('theme', mode);
    };

    const toggleTheme = () => {
        theme === 'dark' ? setMode('light') : setMode('dark');

    };

    useEffect(() => {
        const localTheme = window.localStorage.getItem('theme');

        localTheme ? setTheme(localTheme) : setMode('dark');
    }, [def]);

    return [theme, toggleTheme];
};

// We might need to revert to this if the dark/light glitching continues
// if (def === 'dark') {
//   document.body.style.background = '#252525'
// }
// if (def === 'light') {
//   document.body.style.background = '#fafaff';
//   console.log(document.body.style);
// }
